import type {
  EmployerFootprintAdminViewDto,
  EmployerVerificationDetail,
} from '../../api/employerVerificationDashboardApi';
import type { GateKey } from '../employerVerificationCopy';
import {
  gateDisplayBucketFromStatus,
  resolvedCheckpointDisplayStatus,
} from '../employerVerificationGateAudit';
import { buildStructuralSanityCheckpointView } from './structuralSanityCheckpointPresentation';
import type { ReviewReason } from './reviewReason.types';

const COMMUTE_STEPS = ['COMMUTE_DISTANCE', 'CROSS_PROVINCE_COMMUTE'] as const;

function isIssueStatus(status: string): boolean {
  const u = status.trim().toUpperCase();
  return u === 'FAIL' || u === 'REVIEW';
}

/** Case summary for the standalone commute concern — checkpoint issue text only. */
export function buildCommuteFindingCaseSummary(
  finding: ReviewReason,
  detail: EmployerVerificationDetail | null | undefined,
  footprint: EmployerFootprintAdminViewDto | null | undefined,
): string {
  if (!detail?.gateCheckpointAudit) return finding.explanation;

  for (const stepName of COMMUTE_STEPS) {
    const check = finding.sourceChecks.find(
      (c) => c.step.trim().toUpperCase() === stepName && isIssueStatus(c.status),
    );
    if (!check) continue;

    const auditSteps = detail.gateCheckpointAudit[check.gate as GateKey];
    const cp = auditSteps?.find((s) => s.step.trim().toUpperCase() === stepName);
    if (!cp) continue;

    const bucket = gateDisplayBucketFromStatus(resolvedCheckpointDisplayStatus(cp));
    const view = buildStructuralSanityCheckpointView({
      step: stepName,
      reason: cp.reason ?? '',
      bucket,
      detail,
      footprint: footprint ?? null,
    });

    const lead = view?.issueStatement?.trim();
    if (lead && view?.issueSeverity !== 'info') return lead;
  }

  return finding.explanation;
}
